import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="1" transform="matrix(1 0 0 -1 2.5 7.24609)" fill="currentColor" className="line-fill" />
    <rect width="1" height="18" transform="matrix(1 0 0 -1 29.5 25.2461)" fill="currentColor" className="line-fill" />
    <rect width="1" height="18" transform="matrix(1 0 0 -1 2.5 25.2461)" fill="currentColor" className="line-fill" />
    <rect width="28" height="1" transform="matrix(1 0 0 -1 2.5 26.2461)" fill="currentColor" className="line-fill" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 11.2461H7.5H15.5H16.5V14.2461H15.5V13.2461H12.5V20.2461H13.5V21.2461H9.5V20.2461H10.5V13.2461H7.5V14.2461H6.5V11.2461Z"
      fill="currentColor"
      className="text-fill"
    />
    <rect width="11" height="1" transform="matrix(1 0 0 -1 15.5 18.2461)" fill="currentColor" className="line-fill" />
    <rect width="8" height="1" transform="matrix(1 0 0 -1 18.5 15.2461)" fill="currentColor" className="line-fill" />
    <rect width="8" height="1" transform="matrix(1 0 0 -1 18.5 12.2461)" fill="currentColor" className="line-fill" />
    <rect width="11" height="1" transform="matrix(1 0 0 -1 15.5 21.2461)" fill="currentColor" className="line-fill" />
  </svg>,
  'MarkdownIcon'
);

export const MarkdownIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.text-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.line-fill': {
          color: theme.palette.status.success.main,
        },
      })}
    />
  );
};
